import { render, staticRenderFns } from "./ProblemReporting.vue?vue&type=template&id=35fab2b2&scoped=true"
import script from "./ProblemReporting.vue?vue&type=script&lang=js"
export * from "./ProblemReporting.vue?vue&type=script&lang=js"
import style0 from "./ProblemReporting.vue?vue&type=style&index=0&id=35fab2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fab2b2",
  null
  
)

export default component.exports